// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dcdu","rootMobile":"styles_rootMobile__3sQxN"};